// @flow
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 40px auto;
  min-height: ${({ $height }) => $height}px;
  scroll-margin-top: 80px;
`;

export const Placeholder = styled.div`
  min-height: ${({ $height }) => $height}px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.uiLL};
`;
